import type { SelectableLanguageCode } from "@/models/i18n"
import { DEFAULT_CURRENCY } from "@/utils/constants"
import { defaultDecimalFormatOptions, translateDecimal } from "@/utils/decimal"
import type { DecimalFormatOptions } from "@/utils/decimal"
import { resolveUnitName } from "@/utils/unit"

export interface FormatUsageOptions {
  /** Keep the short label and skip units-system conversion. Defaults to converting. */
  convert?: boolean
}

export const formatUsage = (
  usage: string | number | null | undefined,
  usageUnit: string | null | undefined,
  localeCode: SelectableLanguageCode,
  unitsSystem: string,
  format: DecimalFormatOptions = defaultDecimalFormatOptions,
  options: FormatUsageOptions = {}
): string => {
  const trimmedUnit = usageUnit?.trim() ?? ""
  const hasUnit = trimmedUnit !== ""
  const unit = hasUnit ? resolveUnitName(trimmedUnit) : undefined
  const effectiveUnitsSystem =
    options.convert === false ? undefined : unitsSystem

  if (usage == null || !hasUnit) {
    return translateDecimal({
      format,
      localeCode,
      options: {
        currencyCode: DEFAULT_CURRENCY,
        unitsSystem,
      },
      value: usage,
    })
  }

  const formatted = translateDecimal({
    format,
    localeCode,
    options: {
      currencyCode: DEFAULT_CURRENCY,
      unit,
      unitsSystem: effectiveUnitsSystem,
    },
    value: usage,
  })

  if (unit != null) {
    return formatted
  }

  return `${formatted} ${trimmedUnit}`
}
